import { IUserModel } from '@common/models/UserModel';
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

export interface IUserProfileDetailProps {
    user: IUserModel;
    isVeterinarian: boolean;
}

export const UserProfileDetail = ({ user, isVeterinarian }: IUserProfileDetailProps) => (
    <>
        <Row className="pt-3">
            <Col md={3}>
                <Form.Label>First Name</Form.Label>
                <Form.Control type="text" disabled value={user.firstName} />
            </Col>
            <Col md={3}>
                <Form.Label>Last Name</Form.Label>
                <Form.Control type="text" disabled value={user.lastName} />
            </Col>
            <Col md={3}>
                <Form.Label>Email</Form.Label>
                <Form.Control type="text" disabled value={user.emailAddress} />
            </Col>
            <Col md={3}>
                <Form.Label>Employee ID</Form.Label>
                <Form.Control type="text" disabled value={user.employeeId} />
            </Col>
        </Row>
        <Row className="pt-3">
            <Col md={3}>
                <Form.Label>Employee Type</Form.Label>
                <Form.Control type="text" disabled value={user.employeeType} />
            </Col>
            <Col md={3}>
                <Form.Label>Employment Status</Form.Label>
                <Form.Control type="text"  disabled value={user.employmentStatusName}
                />
            </Col>
            {isVeterinarian && <Col md={3}>
                <Form.Label>Universal Provider Id</Form.Label>
                <Form.Control type="text"  disabled value={user.universalProviderId}
                />
            </Col>}
        </Row>
    </>
);
